<template>
  <div class="user-guide">
    <div class="title">{{ $t('layout.guideLayout.title') }}</div>
    <div class="sub-title">{{ $t('layout.guideLayout.step1') }}</div>
    <p>{{ $t('layout.guideLayout.p1') }}</p>
    <p>{{ $t('layout.guideLayout.p2') }}</p>

    <div class="platform-list">
      <div
        @click="handleBindStore('amazon')"
        class="platform-item"
      >
        <div class="box">
          <span class="name">Amazon</span>
          <span class="badge">{{ $t('layout.guideLayout.amazon.title') }}</span>
        </div>
        <div>{{ $t('layout.guideLayout.amazon.click') }}</div>
      </div>

      <div
        @click="handleBindStore('shopify')"
        class="platform-item"
      >
        <div class="box">
          <span class="name">
            <img
              width="46"
              height="46"
              src="@/assets/platform/shopify.png"
              style="margin-bottom: -3px"
            />
            Shopify
          </span>
        </div>
        <div>{{ $t('layout.guideLayout.shopify.click') }}</div>
      </div>

      <div
        @click="handleBindStore('semitemu')"
        class="platform-item"
      >
        <div class="box">
          <span class="name">
            <img
              width="36"
              height="36"
              src="@/assets/platform/semitemu.png"
              style="margin-right: 5px; margin-bottom: 4px; border-radius: 10px;"
            />
            TEMU半托管
          </span>
        </div>
        <div>{{ $t('layout.guideLayout.temu.click') }}</div>
      </div>

      <div
        @click="handleBindStore('tiktok')"
        class="platform-item"
      >
        <div class="box">
          <span class="name">
            <img
              width="36"
              height="36"
              src="@/assets/platform/tiktok.png"
              style="margin-right: 5px; margin-bottom: 3px;"
            />
            Tiktok
          </span>
        </div>
        <div>{{ $t('layout.guideLayout.tiktok.click') }}</div>
      </div>

      <div class="platform-item platform-item-more">
        <div class="box">
          <span class="tips">{{ $t('layout.guideLayout.morePlatform') }}</span>
        </div>
      </div>
    </div>

    <p class="bottom-tips">
      {{ $t('layout.guideLayout.p3') }}
      <a @click.prevent="toDemo">{{ $t('layout.guideLayout.p4') }}</a>
      {{ $t('layout.guideLayout.p5') }}
    </p>
    <p>{{ $t('layout.guideLayout.p2') }}</p>

    <!-- 店铺授权 -->
    <a-modal
      v-model="open"
      :title="$t('layout.guideLayout.店铺授权')"
      :bodyStyle="{
        padding: '0 10px 0 30px',
        backgroundColor: 'white',
        height: modalHeight
      }"
      :width="730"
      :footer="null"
      :maskClosable="false"
      destroy-on-close
    >
      <iframe
        ref="StoreAuthRef"
        :src="iframeSrc"
        style="width: 100%; height: 100%; border-radius: 0px; overflow: hidden; border: unset"
      ></iframe>
    </a-modal>
    <ModalSuccess ref="ModalSuccessRef"></ModalSuccess>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getCompanyCode } from '@/utils/util'
import ModalSuccess from './ModalSuccess.vue'
import { switchDemo } from '@/api/sso/subjectService'
import qs from 'qs'

export default {
  name: 'UserGuide',
  components: { ModalSuccess },
  data() {
    return {
      open: false,
      modalHeight: '300px',
      platform: 'amazon'
    }
  },
  computed: {
    ...mapGetters(['guidePageProcess']),
    iframeSrc() {
      const { companyCode, company } = getCompanyCode()
      const iconUrl = {
        amazon:
          'http://erp-huanan.oss-cn-shenzhen.aliyuncs.com/platform_account/eccang/png/2020/08/24/20200824141750_3kuu9amazon.png',
        shopify:
          'http://erp-huanan.oss-cn-shenzhen.aliyuncs.com/platform_account/eccang/png/2020/08/26/20200826094950_oojnrshopify.png',
        semitemu:
          'https://erp-huanan.oss-cn-shenzhen.aliyuncs.com/platform_account/eccang/png/2023/08/22/20230822104850_gyvamtemu.png'
      }
      const query = {
        source: 'erp',
        companyCode: companyCode || company,
        customerCode: '',
        grantType: 'AUTH',
        platform: this.platform,
        is_show_usa: this.platform === 'tiktok' ? 0 : 1,
        iconUrl: iconUrl?.[this.platform]
      }
      return `${process.env.VUE_APP_AUTH_URL}/authFormPageNew?${qs.stringify(query)}`
    }
  },
  methods: {
    toDemo() {
      switchDemo({
        demoEnvironment: 'SAIL'
      }).then(({ data }) => {
        if (data) {
          window.open(`//${data.url}/entry/${data.serviceId}/ERP?token=${data.token}`)
        }
      })
    },
    message(e) {
      const { method, data } = e.data

      switch (method) {
        case 'closeAuthAlert':
          this.open = false
          this.$refs.ModalSuccessRef.open = true
          break
        case 'messageAuthHeight':
          if (data?.height) this.modalHeight = `${(data?.height ?? 300) + 160}px`
          break
      }
    },
    handleBindStore(platform) {
      this.platform = platform
      this.open = true
    }
  },
  mounted() {
    window.addEventListener('message', this.message)

    this.$once('hook:destroyed', () => {
      window.removeEventListener('message', this.message)
    })
  }
}
</script>

<style lang="less" scoped>
.user-guide {
  overflow-y: auto;
  font-size: 14px;
  padding: 60px;
  color: #000000;
  .title {
    font-size: 40px;
    text-align: center;
    font-weight: bolder;
  }
  .sub-title {
    font-size: 18px;
    font-weight: bold;
    margin-top: 30px;
  }

  .platform-list {
    display: flex;
    flex-wrap: wrap;
    margin: 35px 0 0;
    .platform-item {
      text-align: center;
      cursor: pointer;
      margin-right: 32px;
      margin-bottom: 32px;
      .box {
        position: relative;
        padding: 40px 0px;
        width: 306px;
        height: 126px;
        text-align: center;
        background-color: white;
        border-radius: 8px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
        }
        .name {
          font-size: 26px;
          font-weight: bold;
          display: flex;
          align-items: flex-end;
        }
        .badge {
          position: absolute;
          height: 25px;
          bottom: 0;
          right: 0;
          width: 100%;
          background-color: #e51015;
          color: white;
          padding: 5px 5px 8px 8px;
          border-radius: 0px 0px 10px 10px;
          font-size: 11px;
        }
      }
    }
    .platform-item-more {
      cursor: not-allowed;
      .box {
        &:hover {
          box-shadow: unset;
        }
      }
    }
  }

  .tips {
    color: #7e6d6d;
    font-size: 16px;
  }
  .bottom-tips {
    margin-top: 80px;
  }
}
</style>
